module.exports = __webpack_public_path__ + "media/svg/flecheblanche-db4fe6c4.svg";